import { api } from '@/helpers/core'
import { AxiosResponse } from 'axios'

export interface List {
	name: string
}

export interface RemoveEntityList {
	id: string
	listName: string
}

export interface EntityList {
	id?: string
	listName: string
	reason: string
	added?: number
}

export interface RemoveListEntity {
	id: string
	listName: string
}

export interface UploadListEntity {
	definitionName: string
	listName: string
	reason: string
	files: any[]
}

export interface ListEntity {
	id: string
	definitionName: string
	value: any
	listName: string
	reason?: string
	added?: number
}

export default {
	get (): Promise<AxiosResponse<List[]>> {
		return api.get('/settings/lists/')
	},

	add (name: string): Promise<AxiosResponse<List>> {
		return api.post('/settings/lists/', { name })
	},

	remove (name: string): Promise<AxiosResponse<void>> {
		return api.post('/settings/lists/delete', { name })
	},

	getLists (entityId: string): Promise<AxiosResponse<EntityList[]>> {
		return api.get('/settings/lists/getLists/' + entityId)
	},

	getEntities (listName: string): Promise<AxiosResponse<ListEntity[]>> {
		return api.get('/settings/lists/getEntities/' + listName)
	},

	addToList ({ id, listName, reason }: EntityList): Promise<AxiosResponse<EntityList>> {
		return api.post('/settings/lists/addToList', { id, listName, reason })
	},

	removeFromList ({ id, listName }: RemoveEntityList): Promise<AxiosResponse<void>> {
		return api.post('/settings/lists/removeFromList', { id, listName, reason: '' })
	},

	addEntity ({ id, listName, definitionName, value, reason }: ListEntity):Promise<AxiosResponse<ListEntity>> {
		return api.post('/settings/lists/addEntity', { id, listName, definitionName, value, reason })
	},

	removeEntity ({ id, listName }: RemoveListEntity): Promise<AxiosResponse<void>> {
		return api.post('/settings/lists/removeEntity', { id, listName, reason: '' })
	},

	upload ({ listName, definitionName, reason, files }: UploadListEntity): Promise<AxiosResponse<ListEntity[]>> {
		const data = new FormData()
		data.append('listName', listName)
		data.append('definitionName', definitionName)
		data.append('reason', reason!!)
		files.forEach((file, index) => data.append('files', file))
		return api.post('/settings/lists/upload', data)
	}
}
